import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { ImageFormats } from "../../../components/finalForms/libs/data/imageFormatTypes";
import { GridColumnType } from "../../../data/gridColumnType";


const initState = {
  profilePic: null,
  firstName: "",
  lastName: "",
  userName: "",
  phone: "",
  emailAddress: "",
  gender: "Male",
  // locationId: "",
  // organizationId: "",
  // roleId: "",
  // userId: '',
  // repotingManager: '',

};

export const profileSettings = {
  name: "User Form",
  initialState: initState,
  section: [
    {
      sectionId: "useDetails",
      title: "User Section",
      row: {},
      style: {
        sectionStyle: "col-lg-4 col-md-4",
      },
      fields: [
        {
          id: "profilePic",
          Field_Name: "user profile",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "profilePic",
          fieldSetting: {
            placeholder: "Upload User Logo",
            allowMultipleImage: false,
            imageUpload: true,
            isDownloadable: false,
            minImageSizeInMB: 0,
            maxImageSizeInMB: 2,
            acceptedImageFormats: [ImageFormats.JPEG, ImageFormats.JPG, ImageFormats.PNG],
            // acceptedImageFormats: [ImageFormats.JPG]
          },
          validation: [{ type: validationTypes.IMAGE }],
          style: {
            containerCss:
              "col-lg-12 col-md-12 col-sm-12 mb-2 file-upload-container ",
          },
        },
      ],
    },
    {
      sectionId: "useDetails",
      title: "User Section",
      row: {},
      style: {
        sectionStyle: "col-lg-8 col-md-8",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
// {
        //   id: "profilePic",
        //   Field_Name: "user profile",
        //   fieldType: FormFieldTypes.IMAGE,
        //   dataField: "profilePic",
        //   fieldSetting: {
        //     placeholder: "Upload User Logo",
        //     allowMultipleImage: false,
        //     imageUpload: true,
        //     isDownloadable: false,
        //     minImageSizeInMB: 0,
        //     maxImageSizeInMB: 2,
        //     acceptedImageFormats: [ImageFormats.JPEG, ImageFormats.JPG, ImageFormats.PNG],
        //     // acceptedImageFormats: [ImageFormats.JPG]
        //   },
        //   validation: [{ type: validationTypes.IMAGE }],
        //   style: {
        //     containerCss:
        //       "col-lg-3 col-md-3 col-sm-6 mb-2 file-upload-container ",
        //   },
        // },
        {
          id: "firstName",
          label: "First Name",
          Field_Name: "first name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "firstName",
          fieldSetting: {
            placeholder: "Please Enter First Name",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
          },
        },
        {
          id: "lastName",
          label: "Last Name",
          Field_Name: "last name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "lastName",
          fieldSetting: {
            placeholder: "Please Enter Last Name",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
          },
        },
        {
          id: "userName",
        label: "User Name",
        Field_Name: "user name",
        fieldType: FormFieldTypes.INPUT,
        dataField: "userName",
        fieldSetting: {
        placeholder: "Please Enter User Name",
        allowSpace: true,
        isDisable:true
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
        },
        },
        {
          id: "emailAddress",
        label: "Email Address",
        Field_Name: "email address",
        fieldType: FormFieldTypes.INPUT,
        dataField: "emailAddress",
        fieldSetting: {
        placeholder: "Please Enter Email Address",
        allowSpace: true,
        isDisable:true,
          },
        validation: [
        {
              type: validationTypes.EMAIL,
        },
        ],
        style: {
        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
        },
        },
        // {
        //   id: "locationId",
        //   label: "Organization Location",
        //   Field_Name: "organization location",
        //   fieldType: FormFieldTypes.SELECT,
        //   dataField: "locationId",
        //   fieldSetting: {
        //     placeholder: "Please Select Organization Location",
        //     allowSpace: true,
        //     options: [],
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
        //   },
        // },
        {
          id: "contactNumber",
          label: "Contact Number",
          Field_Name: "Contact number",
          fieldType: FormFieldTypes.PHONE,
          dataField: "phone",
          fieldSetting: {
            placeholder: "Please Enter Contact Number",
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
          },
        },


        // {
        //   id: "roleId",
        //   label: "Roles",
        //   Field_Name: "roles",
        //   fieldType: FormFieldTypes.SELECT,
        //   dataField: "roleId",
        //   fieldSetting: {
        //     placeholder: "Please Select Role",
        //     allowSpace: true,
        //     options: [],
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
        //   },
        // },
        
        // {
        //   id: "repotingManager",
        //   label: "Reporting Manager",
        //   Field_Name: "Reporting Manager",
        //   fieldType: FormFieldTypes.SELECT,
        //   dataField: "repotingManager",
        //   fieldSetting: {
        //     placeholder: "Please Select Reported Manager",
        //     allowSpace: true,
        //     options: [],
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
        //   },
        // },
        {
          id: "gender",
          label: "Gender : ",
          Field_Name: "gender",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "gender",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "Male", label: "Male" },
              { value: "Female", label: "Female" },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 radioStyle col-md-6 radiio-btn-validation",
          },
        },
        // {
        //   id: "isSupperAdmin",
        //   label: "Is Super Admin",
        //   Field_Name: "issuperadmin",
        //   fieldType: FormFieldTypes.CHECKBOX,
        //   dataField: "isSupperAdmin",
        //   fieldSetting: {
        //     allowSpace: true,
        //   },
        //   // validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss:
        //       "col-lg-3 col-md-3 col-12 validation-left-0 align-item-center justify-content-start checkbox-style min-width width-100",
        //   },
        // },
        // {
        //   id: "active",
        //   label: "Active",
        //   Field_Name: "active",
        //   fieldType: FormFieldTypes.CHECKBOX,
        //   dataField: "isActive",
        //   fieldSetting: {
        //     allowSpace: true,
        //   },
        //   // validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss:
        //       "col-lg-3 col-md-3 col-12 validation-left-0 checkbox-style min-width width-100",
        //   },
        // },
      ],
    },
    // {
    //   title: "User Logo Section",
    //   row: {},
    //   style: {
    //     sectionStyle: "col-lg-3 col-md-6 mb-1",
    //   },
    //   fields: [
    //     {
    //       id: "profilePic",
    //       Field_Name: "user profile",
    //       fieldType: FormFieldTypes.IMAGE,
    //       dataField: "profilePic",
    //       fieldSetting: {
    //         placeholder: "Upload User Logo",
    //         allowMultipleImage: false,
    //         imageUpload: true,
    //         isDownloadable: false,
    //         minImageSizeInMB: 0,
    //         maxImageSizeInMB: 2,
    //         acceptedImageFormats: [ImageFormats.JPEG, ImageFormats.JPG, ImageFormats.PNG],
    //         // acceptedImageFormats: [ImageFormats.JPG]
    //       },
    //       validation: [{ type: validationTypes.IMAGE }],
    //       style: {
    //         containerCss:
    //           "col-lg-12 col-md-6 mb-1 file-upload-container validation-left-0",
    //       },
    //     },
    //   ],
    // },
  ],
};

export const profileSettingsConfiguration = {
  columns: [
    {
      name: "Full Name",
      fieldName: "fullName",
    },
    {
      name: "User Name",
      fieldName: "userName",
    },
    {
      name: "Email Address",
      fieldName: "emailAddress",
    },

    {
      name: "Role Name",
      fieldName: "roleName",
    },
    // {
    //   name: "phone number",
    //   fieldName: "phone",
    // },
    {
      name: "Reporting Manager",
      fieldName: "reportingManagerName",
    },
    {
      name: "Status",
      colType: GridColumnType.TOGGLE,
      fieldName: "isActive",
      allowShort: false,
      colSettings: {
        allowEdit: true,
      },
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      // customAction: [{
      //   name: "PASSWORD",
      //   iconName: AppIcons.plusIcon
      // }],
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
        //allowUSER: true,
      },
    },
  ],
};

export const addressSettings = {
  name: "User Form",
  initialState: initState,
  section: [
    {
      sectionId: "useDetails",
      title: "User Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
       

        {
          id: "locationId",
          label: "Organization Location",
          Field_Name: "organization location",
          fieldType: FormFieldTypes.SELECT,
          dataField: "locationId",
          fieldSetting: {
            placeholder: "Please Select Organization Location",
            allowSpace: true,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
          },
        },
      ],
    },
    {
      title: "User Logo Section",
      row: {},
      style: {
        sectionStyle: "col-lg-3 col-md-6 mb-1",
      },
      fields: [
        {
          id: "profilePic",
          Field_Name: "user profile",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "profilePic",
          fieldSetting: {
            placeholder: "Upload User Logo",
            allowMultipleImage: false,
            imageUpload: true,
            isDownloadable: false,
            minImageSizeInMB: 0,
            maxImageSizeInMB: 2,
            acceptedImageFormats: [ImageFormats.JPEG, ImageFormats.JPG, ImageFormats.PNG],
            // acceptedImageFormats: [ImageFormats.JPG]
          },
          validation: [{ type: validationTypes.IMAGE }],
          style: {
            containerCss:
              "col-lg-12 col-md-6 mb-1 file-upload-container validation-left-0",
          },
        },
      ],
    },
  ],
};

export const PasswordForm = {
  section: [
    {
      sectionId: 'passwordForm',
      title: "password",
      row: {},
      style: {
        sectionStyle: "col-lg-12",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "Password",
          label: "New Password",
          Field_Name: "new password",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "password",
          fieldSetting: {
            placeholder: "Please Enter New Password",
            allowSpace: false,
            isDisable: false,
          },
          style: {
            containerCss: "col-md-6 mb-1 validation-error-icon",
          },
          validation: [
            { type: validationTypes.PASSWORD },
          ],
        },
        {
          id: "ConfirmPassword",
          label: "Confirm Password",
          Field_Name: "confirm password",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "Confirmpassword",
          fieldSetting: {
            placeholder: "Please Re-enter New Password",
            allowSpace: false,
            isDisable: false,
          },
          style: {
            containerCss: "col-md-6 mb-1 validation-error-icon",
          },
          validation: [
            { type: validationTypes.REQUIRE },
            { type: validationTypes.COMPARE, compareEle: 'password' },
          ],
        },
      ]
    }
  ]
};